import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../redux/actions/index";

import { createStyles, makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import SaveIcon from "@material-ui/icons/Save";

import axios from "../../util/axios-reportonce";
import OverlayLoading from "../Shared/OverlayLoading";
import authHeader from "../../services/auth-header";
import serverSelect from "../../serverSelect";

const useStyles = makeStyles((theme) =>
    createStyles({
        card: {
            marginBottom: theme.spacing(3),
            position: "relative",
        },
    })
);

export default function AddNewCommentBlock(props) {
    const loading = useSelector((state) => state.listing.loading);
    const listingId = useSelector((state) => state.listing.id);
    const dispatch = useDispatch();
    const classes = useStyles();
    const user = useSelector((state) => state.user);
    const server = serverSelect();
    const [newCommentText, setNewCommentText] = useState("");
    const [newCommentLengthError, setNewCommentLengthError] = useState(true);
    const [
        newCommentShowLengthWarning,
        setNewCommentShowLengthWarning,
    ] = useState(false);

    const updateNewComment = (event) => {
        setNewCommentText(event.target.value);
        setNewCommentLengthError(event.target.value.length < 20 ? true : false);
        setNewCommentShowLengthWarning(
            event.target.value.length !== 0 && event.target.value.length < 20
                ? true
                : false
        );
    };

    const submitComment = () => {
        if (newCommentText.length >= 20) {
            axios
                .post(
                    `${server}/api/listings/comments/${listingId}`,
                    {
                        email: user.userData.email,
                        comment: newCommentText,
                    },
                    authHeader(user)
                )
                .then(function (response) {
                    // handle success
                    dispatch(actions.loadSpecificListing(listingId));
                    setNewCommentText("");
                    setNewCommentLengthError(true);
                    setNewCommentShowLengthWarning(false);
                    dispatch(
                        actions.showSnackbar(
                            "Comment successfully added",
                            "success"
                        )
                    );
                })
                .catch(function (error) {
                    // handle error
                    console.log("[EditListingComments.js] error = ", error);
                    dispatch(
                        actions.showSnackbar("Error adding comment", "error")
                    );
                })
                .then(function () {
                    // always executed
                });
        }
    };

    return (
        <Grid item xs={12} md={6}>
            <Card className={classes.card}>
                <CardHeader
                    title={<Typography variant="body1" style={{color: "black"}}>Add Comment</Typography>}
                    subheader={<Typography variant='subtitle1'>Enter a new comment here to save to this listing</Typography>}
                    titleTypographyProps={{ variant: "h6" }}
                    subheaderTypographyProps={{ variant: "body2" }}
                />
                <CardContent>
                    <TextField
                        id="filled-textarea"
                        label="Comment"
                        multiline
                        rows={4}
                        placeholder="Enter your comment here."
                        variant="filled"
                        style={{ width: "100%" }}
                        value={newCommentText}
                        onChange={updateNewComment}
                        disabled={loading}
                    />
                    {newCommentShowLengthWarning ? (
                        <Typography
                            variant="subtitle2"
                            component="p"
                            gutterBottom
                            color="error"
                        >
                            Minimum comment length is 20 characters
                        </Typography>
                    ) : null}
                </CardContent>
                <CardActions disableSpacing>
                    <IconButton
                        aria-label="Edit"
                        disabled={
                            loading || newCommentLengthError ? true : false
                        }
                        onClick={() => submitComment()}
                    >
                        <SaveIcon
                            color={
                                loading || newCommentLengthError
                                    ? "disabled"
                                    : "primary"
                            }
                            titleAccess="Save"
                        />
                    </IconButton>
                </CardActions>
                <OverlayLoading loading={loading} />
            </Card>
        </Grid>
    );
}
